/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import Agent from '../model/Agent';
import AgentAvailableContactSlotsResponse from '../model/AgentAvailableContactSlotsResponse';
import AgentAvailableContactSlotsUpdateRequest from '../model/AgentAvailableContactSlotsUpdateRequest';
import AgentCompatibilityProfile from '../model/AgentCompatibilityProfile';
import AgentCompatibilityProfileRequest from '../model/AgentCompatibilityProfileRequest';
import AgentForbiddenResponse from '../model/AgentForbiddenResponse';
import AgentImpersonationExchangeRequest from '../model/AgentImpersonationExchangeRequest';
import AgentImpersonationExchangeResponse from '../model/AgentImpersonationExchangeResponse';
import AgentImpersonationStatus from '../model/AgentImpersonationStatus';
import AgentIntroductionImage from '../model/AgentIntroductionImage';
import AgentMessageTemplate from '../model/AgentMessageTemplate';
import AgentMessageTemplateReorderRequest from '../model/AgentMessageTemplateReorderRequest';
import AgentMessageTemplateRequest from '../model/AgentMessageTemplateRequest';
import AgentProfileImage from '../model/AgentProfileImage';
import AgentRequest from '../model/AgentRequest';
import AgentUserMemo from '../model/AgentUserMemo';
import AgentUserSalesNote from '../model/AgentUserSalesNote';
import AgentV1AgentCompatibilityProfilePatch422Response from '../model/AgentV1AgentCompatibilityProfilePatch422Response';
import AgentV1AgentGet404Response from '../model/AgentV1AgentGet404Response';
import AgentV1AgentPatch422Response from '../model/AgentV1AgentPatch422Response';
import AgentV1AgentProfilePost404Response from '../model/AgentV1AgentProfilePost404Response';
import AgentV1AiOfferBatchesPost409Response from '../model/AgentV1AiOfferBatchesPost409Response';
import AgentV1AssessmentProposalsAssessmentProposalIdDelete404Response from '../model/AgentV1AssessmentProposalsAssessmentProposalIdDelete404Response';
import AgentV1AssessmentProposalsPost422Response from '../model/AgentV1AssessmentProposalsPost422Response';
import AgentV1ContractApplicationsIdDelete200Response from '../model/AgentV1ContractApplicationsIdDelete200Response';
import AgentV1ContractApplicationsIdDelete404Response from '../model/AgentV1ContractApplicationsIdDelete404Response';
import AgentV1ContractApplicationsIdDelete422Response from '../model/AgentV1ContractApplicationsIdDelete422Response';
import AgentV1ImpersonationGet401Response from '../model/AgentV1ImpersonationGet401Response';
import AgentV1LoginPost401Response from '../model/AgentV1LoginPost401Response';
import AgentV1LoginPostRequest from '../model/AgentV1LoginPostRequest';
import AgentV1LogoutPost200Response from '../model/AgentV1LogoutPost200Response';
import AgentV1LogoutPost401Response from '../model/AgentV1LogoutPost401Response';
import AgentV1NewPasswordsPostRequest from '../model/AgentV1NewPasswordsPostRequest';
import AgentV1PasswordResetsPostRequest from '../model/AgentV1PasswordResetsPostRequest';
import AgentV1PropertiesPropertyIdFavoriteDelete422Response from '../model/AgentV1PropertiesPropertyIdFavoriteDelete422Response';
import AgentV1PropertiesPropertyIdFavoritePatch422Response from '../model/AgentV1PropertiesPropertyIdFavoritePatch422Response';
import AgentV1SalesNotesUsersUserIdPatchRequest from '../model/AgentV1SalesNotesUsersUserIdPatchRequest';
import AiOfferBatch from '../model/AiOfferBatch';
import AiOfferBatchDetailResponse from '../model/AiOfferBatchDetailResponse';
import AiOfferBatchPendingCountResponse from '../model/AiOfferBatchPendingCountResponse';
import AiOfferBatchRequest from '../model/AiOfferBatchRequest';
import AiOfferBatchesResponse from '../model/AiOfferBatchesResponse';
import AiOfferDraftItem from '../model/AiOfferDraftItem';
import AiOfferDraftItemUpdateRequest from '../model/AiOfferDraftItemUpdateRequest';
import AssessmentProposal from '../model/AssessmentProposal';
import AssessmentProposalRequest from '../model/AssessmentProposalRequest';
import BulkInvestmentProposalRequest from '../model/BulkInvestmentProposalRequest';
import BulkInvestmentProposalResponse from '../model/BulkInvestmentProposalResponse';
import Company from '../model/Company';
import CompanyLimitedPropertiesImage from '../model/CompanyLimitedPropertiesImage';
import CompanyLogoImage from '../model/CompanyLogoImage';
import CompanyRequest from '../model/CompanyRequest';
import CompanySalesAchievementsImage from '../model/CompanySalesAchievementsImage';
import ContractApplication from '../model/ContractApplication';
import ContractApplicationPatchRequest from '../model/ContractApplicationPatchRequest';
import ContractApplicationPostRequest from '../model/ContractApplicationPostRequest';
import FilterHistory from '../model/FilterHistory';
import FilterHistoryRequest from '../model/FilterHistoryRequest';
import FilterHistoryUpdateRequest from '../model/FilterHistoryUpdateRequest';
import FirstRegistrationRequest from '../model/FirstRegistrationRequest';
import Id from '../model/Id';
import IdName from '../model/IdName';
import InvalidRequestMessage from '../model/InvalidRequestMessage';
import InvestmentProposal from '../model/InvestmentProposal';
import InvestmentProposalRequest from '../model/InvestmentProposalRequest';
import InvestmentStyleDiagnosisAgent from '../model/InvestmentStyleDiagnosisAgent';
import MasterAgentSearchTag from '../model/MasterAgentSearchTag';
import PaginatedAssessmentProposalsResponse from '../model/PaginatedAssessmentProposalsResponse';
import PaginatedAssessmentProposedPropertiesResponse from '../model/PaginatedAssessmentProposedPropertiesResponse';
import PaginatedInvestmentProposalsResponse from '../model/PaginatedInvestmentProposalsResponse';
import PaginatedInvestmentProposedUsersResponse from '../model/PaginatedInvestmentProposedUsersResponse';
import PaginatedPropertiesResponse from '../model/PaginatedPropertiesResponse';
import PaginatedUsersResponse from '../model/PaginatedUsersResponse';
import Property from '../model/Property';
import PropertySearchEnvelopeRequest from '../model/PropertySearchEnvelopeRequest';
import ProposalDeliveryStatus from '../model/ProposalDeliveryStatus';
import ProposalMatching from '../model/ProposalMatching';
import ProposalMatchingListResponse from '../model/ProposalMatchingListResponse';
import ProposalMatchingUnreadCountResponse from '../model/ProposalMatchingUnreadCountResponse';
import ResponseMessage from '../model/ResponseMessage';
import ScheduledAssessmentProposalConflictsRequest from '../model/ScheduledAssessmentProposalConflictsRequest';
import ScheduledAssessmentProposalConflictsResponse from '../model/ScheduledAssessmentProposalConflictsResponse';
import ScheduledInvestmentProposalConflictsRequest from '../model/ScheduledInvestmentProposalConflictsRequest';
import ScheduledInvestmentProposalConflictsResponse from '../model/ScheduledInvestmentProposalConflictsResponse';
import ScheduledProposalCancellationsRequest from '../model/ScheduledProposalCancellationsRequest';
import ScheduledProposalCancellationsResponse from '../model/ScheduledProposalCancellationsResponse';
import ScheduledProposalDatesResponse from '../model/ScheduledProposalDatesResponse';
import ScoreRequest from '../model/ScoreRequest';
import User from '../model/User';
import UserSearchEnvelopeRequest from '../model/UserSearchEnvelopeRequest';

/**
* PropallyAgentV1 service.
* @module api/PropallyAgentV1Api
* @version 1.0.0
*/
export default class PropallyAgentV1Api {

    /**
    * Constructs a new PropallyAgentV1Api. 
    * @alias module:api/PropallyAgentV1Api
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the agentV1AgentAvailableContactSlotsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentAvailableContactSlotsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentAvailableContactSlotsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 連絡対応可能枠取得
     * @param {module:api/PropallyAgentV1Api~agentV1AgentAvailableContactSlotsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentAvailableContactSlotsResponse}
     */
    agentV1AgentAvailableContactSlotsGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AgentAvailableContactSlotsResponse;
      return this.apiClient.callApi(
        '/agent/v1/agent/available_contact_slots', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentAvailableContactSlotsPut operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentAvailableContactSlotsPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentAvailableContactSlotsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 連絡対応可能枠更新（全置き換え）
     * @param {module:model/AgentAvailableContactSlotsUpdateRequest} agentAvailableContactSlotsUpdateRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1AgentAvailableContactSlotsPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentAvailableContactSlotsResponse}
     */
    agentV1AgentAvailableContactSlotsPut(agentAvailableContactSlotsUpdateRequest, callback) {
      let postBody = agentAvailableContactSlotsUpdateRequest;
      // verify the required parameter 'agentAvailableContactSlotsUpdateRequest' is set
      if (agentAvailableContactSlotsUpdateRequest === undefined || agentAvailableContactSlotsUpdateRequest === null) {
        throw new Error("Missing the required parameter 'agentAvailableContactSlotsUpdateRequest' when calling agentV1AgentAvailableContactSlotsPut");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentAvailableContactSlotsResponse;
      return this.apiClient.callApi(
        '/agent/v1/agent/available_contact_slots', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentCompatibilityProfileGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentCompatibilityProfileGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentCompatibilityProfile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * エージェント相性レーダー設定取得
     * @param {module:api/PropallyAgentV1Api~agentV1AgentCompatibilityProfileGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentCompatibilityProfile}
     */
    agentV1AgentCompatibilityProfileGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AgentCompatibilityProfile;
      return this.apiClient.callApi(
        '/agent/v1/agent/compatibility_profile', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentCompatibilityProfilePatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentCompatibilityProfilePatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentCompatibilityProfile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * エージェント相性レーダー設定更新
     * @param {Object} opts Optional parameters
     * @param {module:model/AgentCompatibilityProfileRequest} [agentCompatibilityProfileRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1AgentCompatibilityProfilePatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentCompatibilityProfile}
     */
    agentV1AgentCompatibilityProfilePatch(opts, callback) {
      opts = opts || {};
      let postBody = opts['agentCompatibilityProfileRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentCompatibilityProfile;
      return this.apiClient.callApi(
        '/agent/v1/agent/compatibility_profile', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Agent} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * エージェント情報1件取得
     * @param {module:api/PropallyAgentV1Api~agentV1AgentGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Agent}
     */
    agentV1AgentGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Agent;
      return this.apiClient.callApi(
        '/agent/v1/agent', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentIntroductionImageDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentIntroductionImageDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * プランナー紹介写真削除（未登録なら何もしない）
     * @param {module:api/PropallyAgentV1Api~agentV1AgentIntroductionImageDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    agentV1AgentIntroductionImageDelete(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/agent/v1/agent/introduction_image', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentIntroductionImagePost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentIntroductionImagePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentIntroductionImage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * プランナー紹介写真登録（1 枚。登録済みなら差し替え）
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1AgentIntroductionImagePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentIntroductionImage}
     */
    agentV1AgentIntroductionImagePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = AgentIntroductionImage;
      return this.apiClient.callApi(
        '/agent/v1/agent/introduction_image', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Agent} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * エージェント情報更新
     * @param {Object} opts Optional parameters
     * @param {module:model/AgentRequest} [agentRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1AgentPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Agent}
     */
    agentV1AgentPatch(opts, callback) {
      opts = opts || {};
      let postBody = opts['agentRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Agent;
      return this.apiClient.callApi(
        '/agent/v1/agent', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AgentProfilePost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AgentProfilePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentProfileImage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * エージェントプロフィール画像登録
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1AgentProfilePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentProfileImage}
     */
    agentV1AgentProfilePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = AgentProfileImage;
      return this.apiClient.callApi(
        '/agent/v1/agent/profile', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferBatchesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの依頼履歴一覧
     * ログイン中のエージェントが出した依頼を新しい順に返します。
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferBatchesResponse}
     */
    agentV1AiOfferBatchesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AiOfferBatchesResponse;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesIdCancellationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdCancellationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferBatch} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの破棄
     * バッチを canceled にします。生成が終わっていない item は skipped で確定します。
     * @param {Number} id 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdCancellationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferBatch}
     */
    agentV1AiOfferBatchesIdCancellationsPost(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1AiOfferBatchesIdCancellationsPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AiOfferBatch;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/{id}/cancellations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesIdConfirmationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdConfirmationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferBatchDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの下書きを全件確認済みにする
     * status=succeeded の item をまとめて確認済みにします。 50 件を1件ずつ PATCH するのは手間なので、確認画面の「全件を確認済みにする」から呼びます。
     * @param {Number} id 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdConfirmationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferBatchDetailResponse}
     */
    agentV1AiOfferBatchesIdConfirmationsPost(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1AiOfferBatchesIdConfirmationsPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AiOfferBatchDetailResponse;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/{id}/confirmations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesIdDeliveriesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdDeliveriesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BulkInvestmentProposalResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの送信
     * status=succeeded かつ確認済みの item だけを、通常の一括提案と同じ登録処理で送信します。 文面はサーバー側の item から読むため、クライアントから送り返す必要はありません。 未確認の item は送られないまま記録として残ります（再送の導線はありません）。 全 item の生成が終わっていない（status=generating の）バッチには 409 を返します。
     * @param {Number} id 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdDeliveriesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BulkInvestmentProposalResponse}
     */
    agentV1AiOfferBatchesIdDeliveriesPost(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1AiOfferBatchesIdDeliveriesPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = BulkInvestmentProposalResponse;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/{id}/deliveries', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesIdGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferBatchDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの下書き明細
     * 確認画面に出す item の一覧。生成完了を待たずに、埋まった分から返ります。
     * @param {Number} id 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferBatchDetailResponse}
     */
    agentV1AiOfferBatchesIdGet(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1AiOfferBatchesIdGet");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AiOfferBatchDetailResponse;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesIdItemsItemIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdItemsItemIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferDraftItem} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの下書き1件の編集
     * 文面の編集と確認済みの切り替え。編集できるのは status=succeeded の item だけです。
     * @param {Number} id 
     * @param {Number} itemId 
     * @param {module:model/AiOfferDraftItemUpdateRequest} aiOfferDraftItemUpdateRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdItemsItemIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferDraftItem}
     */
    agentV1AiOfferBatchesIdItemsItemIdPatch(id, itemId, aiOfferDraftItemUpdateRequest, callback) {
      let postBody = aiOfferDraftItemUpdateRequest;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1AiOfferBatchesIdItemsItemIdPatch");
      }
      // verify the required parameter 'itemId' is set
      if (itemId === undefined || itemId === null) {
        throw new Error("Missing the required parameter 'itemId' when calling agentV1AiOfferBatchesIdItemsItemIdPatch");
      }
      // verify the required parameter 'aiOfferDraftItemUpdateRequest' is set
      if (aiOfferDraftItemUpdateRequest === undefined || aiOfferDraftItemUpdateRequest === null) {
        throw new Error("Missing the required parameter 'aiOfferDraftItemUpdateRequest' when calling agentV1AiOfferBatchesIdItemsItemIdPatch");
      }

      let pathParams = {
        'id': id,
        'item_id': itemId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AiOfferDraftItem;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/{id}/items/{item_id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesIdItemsItemIdRegenerationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdItemsItemIdRegenerationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferDraftItem} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの下書き1件の再生成
     * status=succeeded / failed の item を、このリクエスト内で同期的に再生成します。 pending には戻さず、生成結果（succeeded / failed）を保存して返します。 結果保存時に確認済みも解除されるため、送信前に再確認が必要です。 再生成中は同じバッチの編集・再生成・確認・送信・破棄に409を返します。 pending / skipped の item や、送信済み・破棄済みのバッチも再生成できません。
     * @param {Number} id 
     * @param {Number} itemId 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesIdItemsItemIdRegenerationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferDraftItem}
     */
    agentV1AiOfferBatchesIdItemsItemIdRegenerationsPost(id, itemId, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1AiOfferBatchesIdItemsItemIdRegenerationsPost");
      }
      // verify the required parameter 'itemId' is set
      if (itemId === undefined || itemId === null) {
        throw new Error("Missing the required parameter 'itemId' when calling agentV1AiOfferBatchesIdItemsItemIdRegenerationsPost");
      }

      let pathParams = {
        'id': id,
        'item_id': itemId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AiOfferDraftItem;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/{id}/items/{item_id}/regenerations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesPendingCountGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesPendingCountGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AiOfferBatchPendingCountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの確認待ちバッチ数
     * ナビゲーションのバッジに使う、未処理（generating / ready）のバッチ数を返します。
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesPendingCountGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AiOfferBatchPendingCountResponse}
     */
    agentV1AiOfferBatchesPendingCountGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AiOfferBatchPendingCountResponse;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches/pending_count', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AiOfferBatchesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AiOfferBatchesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Id} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * AIオファーの生成依頼
     * 対象を確定して下書き（item）を作ります。生成そのものは常駐ワーカーが進めるため、 このリクエストでは生成しません。対象は一括提案と同じ絞り込みに閉じ込められ、 そこから外れたユーザーと本日すでに提案済みのユーザーは status=skipped の item になります。 未処理（generating / ready）のバッチが残っているエージェントには 409 を返します。
     * @param {module:model/AiOfferBatchRequest} aiOfferBatchRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1AiOfferBatchesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Id}
     */
    agentV1AiOfferBatchesPost(aiOfferBatchRequest, callback) {
      let postBody = aiOfferBatchRequest;
      // verify the required parameter 'aiOfferBatchRequest' is set
      if (aiOfferBatchRequest === undefined || aiOfferBatchRequest === null) {
        throw new Error("Missing the required parameter 'aiOfferBatchRequest' when calling agentV1AiOfferBatchesPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Id;
      return this.apiClient.callApi(
        '/agent/v1/ai_offer_batches', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsAssessmentProposalIdDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案削除
     * @param {Number} assessmentProposalId 査定提案 ID
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1AssessmentProposalsAssessmentProposalIdDelete(assessmentProposalId, callback) {
      let postBody = null;
      // verify the required parameter 'assessmentProposalId' is set
      if (assessmentProposalId === undefined || assessmentProposalId === null) {
        throw new Error("Missing the required parameter 'assessmentProposalId' when calling agentV1AssessmentProposalsAssessmentProposalIdDelete");
      }

      let pathParams = {
        'assessment_proposal_id': assessmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/{assessment_proposal_id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsAssessmentProposalIdFilesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdFilesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案添付ファイル登録
     * @param {Number} assessmentProposalId 査定提案 ID
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdFilesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1AssessmentProposalsAssessmentProposalIdFilesPost(assessmentProposalId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'assessmentProposalId' is set
      if (assessmentProposalId === undefined || assessmentProposalId === null) {
        throw new Error("Missing the required parameter 'assessmentProposalId' when calling agentV1AssessmentProposalsAssessmentProposalIdFilesPost");
      }

      let pathParams = {
        'assessment_proposal_id': assessmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/{assessment_proposal_id}/files', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsAssessmentProposalIdGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AssessmentProposal} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案1件取得
     * @param {Number} assessmentProposalId 査定提案 ID
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AssessmentProposal}
     */
    agentV1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId, callback) {
      let postBody = null;
      // verify the required parameter 'assessmentProposalId' is set
      if (assessmentProposalId === undefined || assessmentProposalId === null) {
        throw new Error("Missing the required parameter 'assessmentProposalId' when calling agentV1AssessmentProposalsAssessmentProposalIdGet");
      }

      let pathParams = {
        'assessment_proposal_id': assessmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AssessmentProposal;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/{assessment_proposal_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsAssessmentProposalIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案更新 ※リクエストボディのproperty_idは不要
     * @param {Number} assessmentProposalId 査定提案 ID
     * @param {Object} opts Optional parameters
     * @param {module:model/AssessmentProposalRequest} [assessmentProposalRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsAssessmentProposalIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1AssessmentProposalsAssessmentProposalIdPatch(assessmentProposalId, opts, callback) {
      opts = opts || {};
      let postBody = opts['assessmentProposalRequest'];
      // verify the required parameter 'assessmentProposalId' is set
      if (assessmentProposalId === undefined || assessmentProposalId === null) {
        throw new Error("Missing the required parameter 'assessmentProposalId' when calling agentV1AssessmentProposalsAssessmentProposalIdPatch");
      }

      let pathParams = {
        'assessment_proposal_id': assessmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/{assessment_proposal_id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedAssessmentProposalsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案一覧取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:model/ProposalDeliveryStatus} [status] オファー送信状態で絞り込み
     * @param {Date} [proposalDate] 予約日時での絞り込み（予約中一覧のプルダウン用）。scheduled_dates が返した値を無加工で渡すこと。完全一致で比較するため、マイクロ秒が異なる予約は別物として扱う。
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedAssessmentProposalsResponse}
     */
    agentV1AssessmentProposalsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'status': opts['status'],
        'proposal_date': opts['proposalDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedAssessmentProposalsResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Id} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案登録
     * proposal_date に未来日時を指定すると予約送信として登録します。未指定または現在以前の場合は即時送信します。
     * @param {Object} opts Optional parameters
     * @param {module:model/AssessmentProposalRequest} [assessmentProposalRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Id}
     */
    agentV1AssessmentProposalsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['assessmentProposalRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Id;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsScheduledCancellationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsScheduledCancellationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduledProposalCancellationsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案の予約日時指定一括取り消し
     * proposal_date が完全一致する送信予約中（scheduled）の査定提案をすべて取り消します。
     * @param {module:model/ScheduledProposalCancellationsRequest} scheduledProposalCancellationsRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsScheduledCancellationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduledProposalCancellationsResponse}
     */
    agentV1AssessmentProposalsScheduledCancellationsPost(scheduledProposalCancellationsRequest, callback) {
      let postBody = scheduledProposalCancellationsRequest;
      // verify the required parameter 'scheduledProposalCancellationsRequest' is set
      if (scheduledProposalCancellationsRequest === undefined || scheduledProposalCancellationsRequest === null) {
        throw new Error("Missing the required parameter 'scheduledProposalCancellationsRequest' when calling agentV1AssessmentProposalsScheduledCancellationsPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ScheduledProposalCancellationsResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/scheduled_cancellations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsScheduledConflictsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsScheduledConflictsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduledAssessmentProposalConflictsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案の同日予約チェック
     * 指定した物件のうち、proposal_date と同じ暦日（JST）に送信予約が入っているものを返します。予約送信の確認モーダル表示に利用します。
     * @param {module:model/ScheduledAssessmentProposalConflictsRequest} scheduledAssessmentProposalConflictsRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsScheduledConflictsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduledAssessmentProposalConflictsResponse}
     */
    agentV1AssessmentProposalsScheduledConflictsPost(scheduledAssessmentProposalConflictsRequest, callback) {
      let postBody = scheduledAssessmentProposalConflictsRequest;
      // verify the required parameter 'scheduledAssessmentProposalConflictsRequest' is set
      if (scheduledAssessmentProposalConflictsRequest === undefined || scheduledAssessmentProposalConflictsRequest === null) {
        throw new Error("Missing the required parameter 'scheduledAssessmentProposalConflictsRequest' when calling agentV1AssessmentProposalsScheduledConflictsPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ScheduledAssessmentProposalConflictsResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/scheduled_conflicts', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsScheduledDatesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsScheduledDatesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduledProposalDatesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 査定提案の予約日時一覧取得
     * 送信予約中（scheduled）の査定提案を proposal_date の値そのもので集計し、日時昇順で返します。丸めないため、この値をそのまま予約日時指定の一括取り消しへ渡せます。
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsScheduledDatesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduledProposalDatesResponse}
     */
    agentV1AssessmentProposalsScheduledDatesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ScheduledProposalDatesResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/scheduled_dates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposalsSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposalsSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedAssessmentProposalsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 物件検索
     * @param {Object} opts Optional parameters
     * @param {module:model/ProposalDeliveryStatus} [status] オファー送信状態で絞り込み
     * @param {Date} [proposalDate] 予約日時での絞り込み（予約中一覧のプルダウン用）。scheduled_dates が返した値を無加工で渡すこと。完全一致で比較するため、マイクロ秒が異なる予約は別物として扱う。
     * @param {module:model/PropertySearchEnvelopeRequest} [propertySearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposalsSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedAssessmentProposalsResponse}
     */
    agentV1AssessmentProposalsSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['propertySearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
        'status': opts['status'],
        'proposal_date': opts['proposalDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedAssessmentProposalsResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposals/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposedPropertiesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposedPropertiesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedAssessmentProposedPropertiesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案済みユニーク物件一覧取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposedPropertiesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedAssessmentProposedPropertiesResponse}
     */
    agentV1AssessmentProposedPropertiesGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedAssessmentProposedPropertiesResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposed_properties', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1AssessmentProposedPropertiesSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1AssessmentProposedPropertiesSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedAssessmentProposedPropertiesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案済みユニーク物件検索
     * @param {Object} opts Optional parameters
     * @param {module:model/PropertySearchEnvelopeRequest} [propertySearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1AssessmentProposedPropertiesSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedAssessmentProposedPropertiesResponse}
     */
    agentV1AssessmentProposedPropertiesSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['propertySearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedAssessmentProposedPropertiesResponse;
      return this.apiClient.callApi(
        '/agent/v1/assessment_proposed_properties/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1CompanyGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1CompanyGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Company} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 企業情報取得
     * @param {module:api/PropallyAgentV1Api~agentV1CompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Company}
     */
    agentV1CompanyGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Company;
      return this.apiClient.callApi(
        '/agent/v1/company', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1CompanyLimitedPropertiesImagesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1CompanyLimitedPropertiesImagesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CompanyLimitedPropertiesImage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Propally限定物件画像登録
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1CompanyLimitedPropertiesImagesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CompanyLimitedPropertiesImage}
     */
    agentV1CompanyLimitedPropertiesImagesPost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = CompanyLimitedPropertiesImage;
      return this.apiClient.callApi(
        '/agent/v1/company_limited_properties_images', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1CompanyLogoImagePost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1CompanyLogoImagePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CompanyLogoImage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 企業ロゴ画像登録
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1CompanyLogoImagePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CompanyLogoImage}
     */
    agentV1CompanyLogoImagePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = CompanyLogoImage;
      return this.apiClient.callApi(
        '/agent/v1/company_logo_image', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1CompanyPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1CompanyPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Company} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 企業情報更新
     * @param {Object} opts Optional parameters
     * @param {module:model/CompanyRequest} [companyRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1CompanyPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Company}
     */
    agentV1CompanyPatch(opts, callback) {
      opts = opts || {};
      let postBody = opts['companyRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Company;
      return this.apiClient.callApi(
        '/agent/v1/company', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1CompanySalesAchievementsImagesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1CompanySalesAchievementsImagesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CompanySalesAchievementsImage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 企業販売実績画像登録
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1CompanySalesAchievementsImagesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CompanySalesAchievementsImage}
     */
    agentV1CompanySalesAchievementsImagesPost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = CompanySalesAchievementsImage;
      return this.apiClient.callApi(
        '/agent/v1/company_sales_achievements_images', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ContractApplicationsContractApplicationIdFilesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ContractApplicationsContractApplicationIdFilesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 成約申請添付ファイル登録
     * @param {Number} contractApplicationId 成約申請 ID
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1ContractApplicationsContractApplicationIdFilesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1ContractApplicationsContractApplicationIdFilesPost(contractApplicationId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'contractApplicationId' is set
      if (contractApplicationId === undefined || contractApplicationId === null) {
        throw new Error("Missing the required parameter 'contractApplicationId' when calling agentV1ContractApplicationsContractApplicationIdFilesPost");
      }

      let pathParams = {
        'contract_application_id': contractApplicationId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/contract_applications/{contract_application_id}/files', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ContractApplicationsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ContractApplicationsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ContractApplication>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 成約申請一覧取得
     * @param {module:api/PropallyAgentV1Api~agentV1ContractApplicationsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ContractApplication>}
     */
    agentV1ContractApplicationsGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ContractApplication];
      return this.apiClient.callApi(
        '/agent/v1/contract_applications', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ContractApplicationsIdDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ContractApplicationsIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentV1ContractApplicationsIdDelete200Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 成約申請削除
     * 空の契約申請（ContractApplication）を削除する 
     * @param {Number} id 削除する契約申請のID
     * @param {module:api/PropallyAgentV1Api~agentV1ContractApplicationsIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentV1ContractApplicationsIdDelete200Response}
     */
    agentV1ContractApplicationsIdDelete(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1ContractApplicationsIdDelete");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AgentV1ContractApplicationsIdDelete200Response;
      return this.apiClient.callApi(
        '/agent/v1/contract_applications/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ContractApplicationsIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ContractApplicationsIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 成約申請更新
     * @param {Number} id 成約申請 ID
     * @param {Object} opts Optional parameters
     * @param {module:model/ContractApplicationPatchRequest} [contractApplicationPatchRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1ContractApplicationsIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1ContractApplicationsIdPatch(id, opts, callback) {
      opts = opts || {};
      let postBody = opts['contractApplicationPatchRequest'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1ContractApplicationsIdPatch");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/contract_applications/{id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ContractApplicationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ContractApplicationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 成約申請登録
     * @param {Object} opts Optional parameters
     * @param {module:model/ContractApplicationPostRequest} [contractApplicationPostRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1ContractApplicationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1ContractApplicationsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['contractApplicationPostRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/contract_applications', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FavoritedPropertiesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FavoritedPropertiesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Property>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入り物件一覧取得
     * @param {module:api/PropallyAgentV1Api~agentV1FavoritedPropertiesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Property>}
     */
    agentV1FavoritedPropertiesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Property];
      return this.apiClient.callApi(
        '/agent/v1/favorited/properties', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FavoritedSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FavoritedSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入りユーザ一内検索
     * @param {Object} opts Optional parameters
     * @param {module:model/UserSearchEnvelopeRequest} [userSearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1FavoritedSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedUsersResponse}
     */
    agentV1FavoritedSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['userSearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/favorited/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FavoritedUsersGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FavoritedUsersGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入りユーザ一覧取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:model/String} [sort = 'id_desc')] ソート順
     * @param {module:api/PropallyAgentV1Api~agentV1FavoritedUsersGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedUsersResponse}
     */
    agentV1FavoritedUsersGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'sort': opts['sort']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/favorited/users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FilterHistoriesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FilterHistoriesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FilterHistory>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 絞り込み履歴一覧取得
     * @param {Object} opts Optional parameters
     * @param {String} [screenKey] 
     * @param {module:api/PropallyAgentV1Api~agentV1FilterHistoriesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FilterHistory>}
     */
    agentV1FilterHistoriesGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'screen_key': opts['screenKey']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [FilterHistory];
      return this.apiClient.callApi(
        '/agent/v1/filter_histories', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FilterHistoriesIdDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FilterHistoriesIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FilterHistory>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 絞り込み履歴削除
     * @param {String} id 
     * @param {module:api/PropallyAgentV1Api~agentV1FilterHistoriesIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FilterHistory>}
     */
    agentV1FilterHistoriesIdDelete(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1FilterHistoriesIdDelete");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [FilterHistory];
      return this.apiClient.callApi(
        '/agent/v1/filter_histories/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FilterHistoriesIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FilterHistoriesIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FilterHistory>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 絞り込み履歴更新（タイトル/命名）
     * @param {String} id 
     * @param {module:model/FilterHistoryUpdateRequest} filterHistoryUpdateRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1FilterHistoriesIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FilterHistory>}
     */
    agentV1FilterHistoriesIdPatch(id, filterHistoryUpdateRequest, callback) {
      let postBody = filterHistoryUpdateRequest;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1FilterHistoriesIdPatch");
      }
      // verify the required parameter 'filterHistoryUpdateRequest' is set
      if (filterHistoryUpdateRequest === undefined || filterHistoryUpdateRequest === null) {
        throw new Error("Missing the required parameter 'filterHistoryUpdateRequest' when calling agentV1FilterHistoriesIdPatch");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = [FilterHistory];
      return this.apiClient.callApi(
        '/agent/v1/filter_histories/{id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FilterHistoriesIdTouchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FilterHistoriesIdTouchPostCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FilterHistory>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 絞り込み履歴の利用更新
     * @param {String} id 
     * @param {module:api/PropallyAgentV1Api~agentV1FilterHistoriesIdTouchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FilterHistory>}
     */
    agentV1FilterHistoriesIdTouchPost(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1FilterHistoriesIdTouchPost");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [FilterHistory];
      return this.apiClient.callApi(
        '/agent/v1/filter_histories/{id}/touch', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1FilterHistoriesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1FilterHistoriesPostCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FilterHistory>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 絞り込み履歴登録（同条件は更新）
     * @param {module:model/FilterHistoryRequest} filterHistoryRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1FilterHistoriesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FilterHistory>}
     */
    agentV1FilterHistoriesPost(filterHistoryRequest, callback) {
      let postBody = filterHistoryRequest;
      // verify the required parameter 'filterHistoryRequest' is set
      if (filterHistoryRequest === undefined || filterHistoryRequest === null) {
        throw new Error("Missing the required parameter 'filterHistoryRequest' when calling agentV1FilterHistoriesPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = [FilterHistory];
      return this.apiClient.callApi(
        '/agent/v1/filter_histories', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ImpersonationDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ImpersonationDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 代行ログイン終了
     * @param {module:api/PropallyAgentV1Api~agentV1ImpersonationDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1ImpersonationDelete(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/impersonation', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ImpersonationExchangePost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ImpersonationExchangePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentImpersonationExchangeResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 代理ログイン用 one-time code を access token に交換
     * @param {module:model/AgentImpersonationExchangeRequest} agentImpersonationExchangeRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1ImpersonationExchangePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentImpersonationExchangeResponse}
     */
    agentV1ImpersonationExchangePost(agentImpersonationExchangeRequest, callback) {
      let postBody = agentImpersonationExchangeRequest;
      // verify the required parameter 'agentImpersonationExchangeRequest' is set
      if (agentImpersonationExchangeRequest === undefined || agentImpersonationExchangeRequest === null) {
        throw new Error("Missing the required parameter 'agentImpersonationExchangeRequest' when calling agentV1ImpersonationExchangePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentImpersonationExchangeResponse;
      return this.apiClient.callApi(
        '/agent/v1/impersonation/exchange', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ImpersonationGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ImpersonationGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentImpersonationStatus} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 代行ログイン状態取得
     * @param {module:api/PropallyAgentV1Api~agentV1ImpersonationGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentImpersonationStatus}
     */
    agentV1ImpersonationGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AgentImpersonationStatus;
      return this.apiClient.callApi(
        '/agent/v1/impersonation', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsBulkDeliveriesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsBulkDeliveriesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BulkInvestmentProposalResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 一括投資提案登録（未提案ユーザー向け）
     * チェック選択（user_ids）または検索条件（search）で対象を確定し、提案行を一括作成してバックグラウンドで順次送信します。対象は未提案一覧と同じ絞り込みに閉じ込められ、そこから外れた user_id は skipped_count に計上されます。
     * @param {Object} opts Optional parameters
     * @param {module:model/BulkInvestmentProposalRequest} [bulkInvestmentProposalRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsBulkDeliveriesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BulkInvestmentProposalResponse}
     */
    agentV1InvestmentProposalsBulkDeliveriesPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['bulkInvestmentProposalRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = BulkInvestmentProposalResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/bulk_deliveries', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsBulkReDeliveriesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsBulkReDeliveriesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BulkInvestmentProposalResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 一括投資再提案登録（提案済みユーザー向け）
     * チェック選択（user_ids）または検索条件（search）で対象を確定し、提案行を一括作成してバックグラウンドで順次送信します。対象は提案済み一覧と同じ絞り込みに閉じ込められ、本日提案済みのユーザーとあわせて skipped_count に計上されます。
     * @param {Object} opts Optional parameters
     * @param {module:model/BulkInvestmentProposalRequest} [bulkInvestmentProposalRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsBulkReDeliveriesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BulkInvestmentProposalResponse}
     */
    agentV1InvestmentProposalsBulkReDeliveriesPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['bulkInvestmentProposalRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = BulkInvestmentProposalResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/bulk_re_deliveries', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedInvestmentProposalsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザー情報取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:model/String} [sort = 'id_desc')] ソート順
     * @param {module:model/ProposalDeliveryStatus} [status] オファー送信状態で絞り込み
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedInvestmentProposalsResponse}
     */
    agentV1InvestmentProposalsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'sort': opts['sort'],
        'status': opts['status']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedInvestmentProposalsResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsInvestmentProposalIdDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案削除
     * @param {Number} investmentProposalId 投資提案 ID
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1InvestmentProposalsInvestmentProposalIdDelete(investmentProposalId, callback) {
      let postBody = null;
      // verify the required parameter 'investmentProposalId' is set
      if (investmentProposalId === undefined || investmentProposalId === null) {
        throw new Error("Missing the required parameter 'investmentProposalId' when calling agentV1InvestmentProposalsInvestmentProposalIdDelete");
      }

      let pathParams = {
        'investment_proposal_id': investmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/{investment_proposal_id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsInvestmentProposalIdFilesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdFilesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案添付ファイル登録
     * @param {Number} investmentProposalId 投資提案 ID
     * @param {Object} opts Optional parameters
     * @param {File} [imageBinary] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdFilesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1InvestmentProposalsInvestmentProposalIdFilesPost(investmentProposalId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'investmentProposalId' is set
      if (investmentProposalId === undefined || investmentProposalId === null) {
        throw new Error("Missing the required parameter 'investmentProposalId' when calling agentV1InvestmentProposalsInvestmentProposalIdFilesPost");
      }

      let pathParams = {
        'investment_proposal_id': investmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'image_binary': opts['imageBinary']
      };

      let authNames = [];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/{investment_proposal_id}/files', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsInvestmentProposalIdGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvestmentProposal} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案1件取得
     * @param {Number} investmentProposalId 投資提案 ID
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvestmentProposal}
     */
    agentV1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId, callback) {
      let postBody = null;
      // verify the required parameter 'investmentProposalId' is set
      if (investmentProposalId === undefined || investmentProposalId === null) {
        throw new Error("Missing the required parameter 'investmentProposalId' when calling agentV1InvestmentProposalsInvestmentProposalIdGet");
      }

      let pathParams = {
        'investment_proposal_id': investmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InvestmentProposal;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/{investment_proposal_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsInvestmentProposalIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案更新 ※リクエストボディのuser_idは不要
     * @param {Number} investmentProposalId 投資提案 ID
     * @param {Object} opts Optional parameters
     * @param {module:model/InvestmentProposalRequest} [investmentProposalRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsInvestmentProposalIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1InvestmentProposalsInvestmentProposalIdPatch(investmentProposalId, opts, callback) {
      opts = opts || {};
      let postBody = opts['investmentProposalRequest'];
      // verify the required parameter 'investmentProposalId' is set
      if (investmentProposalId === undefined || investmentProposalId === null) {
        throw new Error("Missing the required parameter 'investmentProposalId' when calling agentV1InvestmentProposalsInvestmentProposalIdPatch");
      }

      let pathParams = {
        'investment_proposal_id': investmentProposalId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/{investment_proposal_id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Id} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案登録
     * proposal_date に未来日時を指定すると予約送信として登録します。未指定または現在以前の場合は即時送信します。
     * @param {Object} opts Optional parameters
     * @param {module:model/InvestmentProposalRequest} [investmentProposalRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Id}
     */
    agentV1InvestmentProposalsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['investmentProposalRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Id;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsScheduledCancellationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsScheduledCancellationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduledProposalCancellationsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案の予約日時指定一括取り消し
     * proposal_date が完全一致する送信予約中（scheduled）の投資提案をすべて取り消します。
     * @param {module:model/ScheduledProposalCancellationsRequest} scheduledProposalCancellationsRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsScheduledCancellationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduledProposalCancellationsResponse}
     */
    agentV1InvestmentProposalsScheduledCancellationsPost(scheduledProposalCancellationsRequest, callback) {
      let postBody = scheduledProposalCancellationsRequest;
      // verify the required parameter 'scheduledProposalCancellationsRequest' is set
      if (scheduledProposalCancellationsRequest === undefined || scheduledProposalCancellationsRequest === null) {
        throw new Error("Missing the required parameter 'scheduledProposalCancellationsRequest' when calling agentV1InvestmentProposalsScheduledCancellationsPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ScheduledProposalCancellationsResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/scheduled_cancellations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsScheduledConflictsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsScheduledConflictsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduledInvestmentProposalConflictsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案の同日予約チェック
     * 指定したユーザーのうち、proposal_date と同じ暦日（JST）に送信予約が入っているユーザーを返します。 予約送信の確認モーダル表示に利用します。 対象はチェック選択（target_type=user_ids）と絞り込み条件（target_type=search）のどちらでも指定でき、 search のときは一括提案と同じロジックで対象を確定するため、モーダルの件数と実際の置き換え対象が一致します。
     * @param {module:model/ScheduledInvestmentProposalConflictsRequest} scheduledInvestmentProposalConflictsRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsScheduledConflictsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduledInvestmentProposalConflictsResponse}
     */
    agentV1InvestmentProposalsScheduledConflictsPost(scheduledInvestmentProposalConflictsRequest, callback) {
      let postBody = scheduledInvestmentProposalConflictsRequest;
      // verify the required parameter 'scheduledInvestmentProposalConflictsRequest' is set
      if (scheduledInvestmentProposalConflictsRequest === undefined || scheduledInvestmentProposalConflictsRequest === null) {
        throw new Error("Missing the required parameter 'scheduledInvestmentProposalConflictsRequest' when calling agentV1InvestmentProposalsScheduledConflictsPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ScheduledInvestmentProposalConflictsResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/scheduled_conflicts', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsScheduledDatesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsScheduledDatesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduledProposalDatesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資提案の予約日時一覧取得
     * 送信予約中（scheduled）の投資提案を proposal_date の値そのもので集計し、日時昇順で返します。丸めないため、この値をそのまま予約日時指定の一括取り消しへ渡せます。
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsScheduledDatesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduledProposalDatesResponse}
     */
    agentV1InvestmentProposalsScheduledDatesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ScheduledProposalDatesResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/scheduled_dates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposalsSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposalsSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedInvestmentProposalsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザ検索
     * @param {Object} opts Optional parameters
     * @param {module:model/ProposalDeliveryStatus} [status] オファー送信状態で絞り込み
     * @param {module:model/UserSearchEnvelopeRequest} [userSearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposalsSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedInvestmentProposalsResponse}
     */
    agentV1InvestmentProposalsSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['userSearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
        'status': opts['status']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedInvestmentProposalsResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposals/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposedUsersGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposedUsersGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedInvestmentProposedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案済みユニークユーザー一覧取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:model/String} [sort = 'id_desc')] ソート順
     * @param {module:model/ProposalDeliveryStatus} [status] オファー送信状態で絞り込み。未指定時は sent として扱う
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposedUsersGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedInvestmentProposedUsersResponse}
     */
    agentV1InvestmentProposedUsersGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'sort': opts['sort'],
        'status': opts['status']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedInvestmentProposedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposed_users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentProposedUsersSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentProposedUsersSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedInvestmentProposedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案済みユニークユーザー検索
     * @param {Object} opts Optional parameters
     * @param {module:model/ProposalDeliveryStatus} [status] オファー送信状態で絞り込み。未指定時は sent として扱う
     * @param {module:model/UserSearchEnvelopeRequest} [userSearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentProposedUsersSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedInvestmentProposedUsersResponse}
     */
    agentV1InvestmentProposedUsersSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['userSearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
        'status': opts['status']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedInvestmentProposedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_proposed_users/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentScheduledUsersGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentScheduledUsersGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedInvestmentProposedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 送信予約中の投資提案一覧取得
     * 予約中は「1予約 = 1行」で返す（同一ユーザーが複数予約していれば複数行に出る）。total_count・ページングも予約件数基準。パスは互換のため据え置き。
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:model/String} [sort = 'id_desc')] ソート順
     * @param {Date} [proposalDate] 予約日時での絞り込み。scheduled_dates が返した値を無加工で渡すこと。完全一致で比較するため、マイクロ秒が異なる予約は別物として扱う。
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentScheduledUsersGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedInvestmentProposedUsersResponse}
     */
    agentV1InvestmentScheduledUsersGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'sort': opts['sort'],
        'proposal_date': opts['proposalDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedInvestmentProposedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_scheduled_users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1InvestmentScheduledUsersSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1InvestmentScheduledUsersSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedInvestmentProposedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 送信予約中の投資提案検索
     * 予約中は「1予約 = 1行」で返す（同一ユーザーが複数予約していれば複数行に出る）。total_count・ページングも予約件数基準。
     * @param {Object} opts Optional parameters
     * @param {Date} [proposalDate] 予約日時での絞り込み。scheduled_dates が返した値を無加工で渡すこと。完全一致で比較するため、マイクロ秒が異なる予約は別物として扱う。
     * @param {module:model/UserSearchEnvelopeRequest} [userSearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1InvestmentScheduledUsersSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedInvestmentProposedUsersResponse}
     */
    agentV1InvestmentScheduledUsersSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['userSearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
        'proposal_date': opts['proposalDate']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedInvestmentProposedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/investment_scheduled_users/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1LoginPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1LoginPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Agent} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ログイン
     * @param {Object} opts Optional parameters
     * @param {module:model/AgentV1LoginPostRequest} [agentV1LoginPostRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1LoginPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Agent}
     */
    agentV1LoginPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['agentV1LoginPostRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = Agent;
      return this.apiClient.callApi(
        '/agent/v1/login', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1LogoutPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1LogoutPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentV1LogoutPost200Response} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ログアウト
     * @param {module:api/PropallyAgentV1Api~agentV1LogoutPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentV1LogoutPost200Response}
     */
    agentV1LogoutPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AgentV1LogoutPost200Response;
      return this.apiClient.callApi(
        '/agent/v1/logout', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MasterDataAgentSearchTagsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MasterDataAgentSearchTagsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/MasterAgentSearchTag>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * エージェント検索タグマスタ取得
     * @param {module:api/PropallyAgentV1Api~agentV1MasterDataAgentSearchTagsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/MasterAgentSearchTag>}
     */
    agentV1MasterDataAgentSearchTagsGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [MasterAgentSearchTag];
      return this.apiClient.callApi(
        '/agent/v1/master_data/agent_search_tags', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MasterDataInterestedPropertyTypesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MasterDataInterestedPropertyTypesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/IdName>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 興味のある物件タイプマスタ取得
     * @param {module:api/PropallyAgentV1Api~agentV1MasterDataInterestedPropertyTypesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/IdName>}
     */
    agentV1MasterDataInterestedPropertyTypesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [IdName];
      return this.apiClient.callApi(
        '/agent/v1/master_data/interested_property_types', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MasterDataPrefecturesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MasterDataPrefecturesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 都道府県一覧
     * @param {module:api/PropallyAgentV1Api~agentV1MasterDataPrefecturesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
    agentV1MasterDataPrefecturesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ['String'];
      return this.apiClient.callApi(
        '/agent/v1/master_data/prefectures', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 町丁目一覧
     * @param {String} prefectureName 都道府県名
     * @param {String} cityName 市区町村名
     * @param {module:api/PropallyAgentV1Api~agentV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
    agentV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, callback) {
      let postBody = null;
      // verify the required parameter 'prefectureName' is set
      if (prefectureName === undefined || prefectureName === null) {
        throw new Error("Missing the required parameter 'prefectureName' when calling agentV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet");
      }
      // verify the required parameter 'cityName' is set
      if (cityName === undefined || cityName === null) {
        throw new Error("Missing the required parameter 'cityName' when calling agentV1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet");
      }

      let pathParams = {
        'prefecture_name': prefectureName,
        'city_name': cityName
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ['String'];
      return this.apiClient.callApi(
        '/agent/v1/master_data/prefectures/{prefecture_name}/cities/{city_name}/towns', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MasterDataPrefecturesPrefectureNameCitiesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MasterDataPrefecturesPrefectureNameCitiesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<String>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 市区町村一覧
     * @param {String} prefectureName 都道府県名
     * @param {module:api/PropallyAgentV1Api~agentV1MasterDataPrefecturesPrefectureNameCitiesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<String>}
     */
    agentV1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, callback) {
      let postBody = null;
      // verify the required parameter 'prefectureName' is set
      if (prefectureName === undefined || prefectureName === null) {
        throw new Error("Missing the required parameter 'prefectureName' when calling agentV1MasterDataPrefecturesPrefectureNameCitiesGet");
      }

      let pathParams = {
        'prefecture_name': prefectureName
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ['String'];
      return this.apiClient.callApi(
        '/agent/v1/master_data/prefectures/{prefecture_name}/cities', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MasterDataResidenceTypesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MasterDataResidenceTypesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/IdName>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 居住タイプマスタ取得
     * @param {module:api/PropallyAgentV1Api~agentV1MasterDataResidenceTypesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/IdName>}
     */
    agentV1MasterDataResidenceTypesGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [IdName];
      return this.apiClient.callApi(
        '/agent/v1/master_data/residence_types', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MessageTemplatesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MessageTemplatesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AgentMessageTemplate>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案メッセージテンプレート一覧取得
     * @param {Object} opts Optional parameters
     * @param {module:model/String} [templateType] テンプレートタイプでフィルタリング
     * @param {module:api/PropallyAgentV1Api~agentV1MessageTemplatesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AgentMessageTemplate>}
     */
    agentV1MessageTemplatesGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'template_type': opts['templateType']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AgentMessageTemplate];
      return this.apiClient.callApi(
        '/agent/v1/message_templates', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MessageTemplatesIdDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MessageTemplatesIdDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案メッセージテンプレート削除
     * @param {Number} id テンプレート ID
     * @param {module:api/PropallyAgentV1Api~agentV1MessageTemplatesIdDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    agentV1MessageTemplatesIdDelete(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1MessageTemplatesIdDelete");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/agent/v1/message_templates/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MessageTemplatesIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MessageTemplatesIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentMessageTemplate} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案メッセージテンプレート更新
     * @param {Number} id テンプレート ID
     * @param {module:model/AgentMessageTemplateRequest} agentMessageTemplateRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1MessageTemplatesIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentMessageTemplate}
     */
    agentV1MessageTemplatesIdPatch(id, agentMessageTemplateRequest, callback) {
      let postBody = agentMessageTemplateRequest;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling agentV1MessageTemplatesIdPatch");
      }
      // verify the required parameter 'agentMessageTemplateRequest' is set
      if (agentMessageTemplateRequest === undefined || agentMessageTemplateRequest === null) {
        throw new Error("Missing the required parameter 'agentMessageTemplateRequest' when calling agentV1MessageTemplatesIdPatch");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentMessageTemplate;
      return this.apiClient.callApi(
        '/agent/v1/message_templates/{id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MessageTemplatesPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MessageTemplatesPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentMessageTemplate} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案メッセージテンプレート作成
     * @param {module:model/AgentMessageTemplateRequest} agentMessageTemplateRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1MessageTemplatesPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentMessageTemplate}
     */
    agentV1MessageTemplatesPost(agentMessageTemplateRequest, callback) {
      let postBody = agentMessageTemplateRequest;
      // verify the required parameter 'agentMessageTemplateRequest' is set
      if (agentMessageTemplateRequest === undefined || agentMessageTemplateRequest === null) {
        throw new Error("Missing the required parameter 'agentMessageTemplateRequest' when calling agentV1MessageTemplatesPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentMessageTemplate;
      return this.apiClient.callApi(
        '/agent/v1/message_templates', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1MessageTemplatesReorderPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1MessageTemplatesReorderPostCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AgentMessageTemplate>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 提案メッセージテンプレート並び替え
     * @param {module:model/AgentMessageTemplateReorderRequest} agentMessageTemplateReorderRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1MessageTemplatesReorderPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AgentMessageTemplate>}
     */
    agentV1MessageTemplatesReorderPost(agentMessageTemplateReorderRequest, callback) {
      let postBody = agentMessageTemplateReorderRequest;
      // verify the required parameter 'agentMessageTemplateReorderRequest' is set
      if (agentMessageTemplateReorderRequest === undefined || agentMessageTemplateReorderRequest === null) {
        throw new Error("Missing the required parameter 'agentMessageTemplateReorderRequest' when calling agentV1MessageTemplatesReorderPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = [AgentMessageTemplate];
      return this.apiClient.callApi(
        '/agent/v1/message_templates/reorder', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1NewPasswordsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1NewPasswordsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * リセット後、新しいパスワードの登録
     * @param {Object} opts Optional parameters
     * @param {module:model/AgentV1NewPasswordsPostRequest} [agentV1NewPasswordsPostRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1NewPasswordsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1NewPasswordsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['agentV1NewPasswordsPostRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/new_passwords', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PasswordResetsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PasswordResetsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * パスワードリセット
     * @param {Object} opts Optional parameters
     * @param {module:model/AgentV1PasswordResetsPostRequest} [agentV1PasswordResetsPostRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1PasswordResetsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1PasswordResetsPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['agentV1PasswordResetsPostRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/password_resets', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedPropertiesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * すべての物件一覧取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedPropertiesResponse}
     */
    agentV1PropertiesGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedPropertiesResponse;
      return this.apiClient.callApi(
        '/agent/v1/properties', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesPropertyIdFavoriteDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdFavoriteDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入り物件解除
     * @param {Number} propertyId 物件 ID
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdFavoriteDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1PropertiesPropertyIdFavoriteDelete(propertyId, callback) {
      let postBody = null;
      // verify the required parameter 'propertyId' is set
      if (propertyId === undefined || propertyId === null) {
        throw new Error("Missing the required parameter 'propertyId' when calling agentV1PropertiesPropertyIdFavoriteDelete");
      }

      let pathParams = {
        'property_id': propertyId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/properties/{property_id}/favorite', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesPropertyIdFavoritePatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdFavoritePatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入り物件登録
     * @param {Number} propertyId 物件 ID
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdFavoritePatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1PropertiesPropertyIdFavoritePatch(propertyId, callback) {
      let postBody = null;
      // verify the required parameter 'propertyId' is set
      if (propertyId === undefined || propertyId === null) {
        throw new Error("Missing the required parameter 'propertyId' when calling agentV1PropertiesPropertyIdFavoritePatch");
      }

      let pathParams = {
        'property_id': propertyId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/properties/{property_id}/favorite', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesPropertyIdGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Property} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 物件詳細1件取得
     * @param {Number} propertyId 物件 ID
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Property}
     */
    agentV1PropertiesPropertyIdGet(propertyId, callback) {
      let postBody = null;
      // verify the required parameter 'propertyId' is set
      if (propertyId === undefined || propertyId === null) {
        throw new Error("Missing the required parameter 'propertyId' when calling agentV1PropertiesPropertyIdGet");
      }

      let pathParams = {
        'property_id': propertyId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = Property;
      return this.apiClient.callApi(
        '/agent/v1/properties/{property_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesPropertyIdScoreDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdScoreDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 物件スコア削除
     * @param {Number} propertyId 物件 ID
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdScoreDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1PropertiesPropertyIdScoreDelete(propertyId, callback) {
      let postBody = null;
      // verify the required parameter 'propertyId' is set
      if (propertyId === undefined || propertyId === null) {
        throw new Error("Missing the required parameter 'propertyId' when calling agentV1PropertiesPropertyIdScoreDelete");
      }

      let pathParams = {
        'property_id': propertyId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/properties/{property_id}/score', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesPropertyIdScorePatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdScorePatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 物件スコア登録
     * @param {Number} propertyId 物件 ID
     * @param {module:model/ScoreRequest} scoreRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesPropertyIdScorePatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1PropertiesPropertyIdScorePatch(propertyId, scoreRequest, callback) {
      let postBody = scoreRequest;
      // verify the required parameter 'propertyId' is set
      if (propertyId === undefined || propertyId === null) {
        throw new Error("Missing the required parameter 'propertyId' when calling agentV1PropertiesPropertyIdScorePatch");
      }
      // verify the required parameter 'scoreRequest' is set
      if (scoreRequest === undefined || scoreRequest === null) {
        throw new Error("Missing the required parameter 'scoreRequest' when calling agentV1PropertiesPropertyIdScorePatch");
      }

      let pathParams = {
        'property_id': propertyId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/properties/{property_id}/score', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1PropertiesSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1PropertiesSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedPropertiesResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 物件検索
     * @param {Object} opts Optional parameters
     * @param {module:model/PropertySearchEnvelopeRequest} [propertySearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1PropertiesSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedPropertiesResponse}
     */
    agentV1PropertiesSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['propertySearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedPropertiesResponse;
      return this.apiClient.callApi(
        '/agent/v1/properties/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ProposalMatchingUnreadCountGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ProposalMatchingUnreadCountGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProposalMatchingUnreadCountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * マッチしたオーナーの未読数取得
     * @param {module:api/PropallyAgentV1Api~agentV1ProposalMatchingUnreadCountGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProposalMatchingUnreadCountResponse}
     */
    agentV1ProposalMatchingUnreadCountGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ProposalMatchingUnreadCountResponse;
      return this.apiClient.callApi(
        '/agent/v1/proposal_matching_unread_count', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ProposalMatchingsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ProposalMatchingsGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProposalMatchingListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * マッチしたユーザー一覧取得
     * @param {Object} opts Optional parameters
     * @param {module:model/String} [sortBy] ソート順（デフォルト:match_date_desc）
     * @param {Boolean} [hasAction] アクション済みかどうかでフィルタ（true:アクション済み、false:未アクション）
     * @param {String} [keyword] 氏名または電話番号での部分一致検索
     * @param {Boolean} [isTarget] 対象条件一致で絞り込み（true: 一致のみ、false: 不一致のみ）
     * @param {Number} [page] ページ番号（デフォルト:1）
     * @param {Number} [perPage] 1ページあたりの件数
     * @param {module:api/PropallyAgentV1Api~agentV1ProposalMatchingsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProposalMatchingListResponse}
     */
    agentV1ProposalMatchingsGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'sort_by': opts['sortBy'],
        'has_action': opts['hasAction'],
        'keyword': opts['keyword'],
        'is_target': opts['isTarget'],
        'page': opts['page'],
        'per_page': opts['perPage']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ProposalMatchingListResponse;
      return this.apiClient.callApi(
        '/agent/v1/proposal_matchings', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ProposalMatchingsProposalMatchingIdGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ProposalMatchingsProposalMatchingIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ProposalMatching} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * (ユーザ連絡先含む)提案マッチング情報1件取得
     * @param {Number} proposalMatchingId 提案マッチング ID
     * @param {module:api/PropallyAgentV1Api~agentV1ProposalMatchingsProposalMatchingIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ProposalMatching}
     */
    agentV1ProposalMatchingsProposalMatchingIdGet(proposalMatchingId, callback) {
      let postBody = null;
      // verify the required parameter 'proposalMatchingId' is set
      if (proposalMatchingId === undefined || proposalMatchingId === null) {
        throw new Error("Missing the required parameter 'proposalMatchingId' when calling agentV1ProposalMatchingsProposalMatchingIdGet");
      }

      let pathParams = {
        'proposal_matching_id': proposalMatchingId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ProposalMatching;
      return this.apiClient.callApi(
        '/agent/v1/proposal_matchings/{proposal_matching_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1ProposalMatchingsProposalMatchingIdReadPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1ProposalMatchingsProposalMatchingIdReadPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * マッチしたオーナーのエージェント既読処理
     * @param {Number} proposalMatchingId 提案マッチング ID
     * @param {module:api/PropallyAgentV1Api~agentV1ProposalMatchingsProposalMatchingIdReadPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1ProposalMatchingsProposalMatchingIdReadPatch(proposalMatchingId, callback) {
      let postBody = null;
      // verify the required parameter 'proposalMatchingId' is set
      if (proposalMatchingId === undefined || proposalMatchingId === null) {
        throw new Error("Missing the required parameter 'proposalMatchingId' when calling agentV1ProposalMatchingsProposalMatchingIdReadPatch");
      }

      let pathParams = {
        'proposal_matching_id': proposalMatchingId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/proposal_matchings/{proposal_matching_id}/read', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1RegistrationsPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1RegistrationsPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 企業・エージェントの初回登録 ※これだけではログインできずadmin側で承認処理が必要
     * @param {module:model/FirstRegistrationRequest} firstRegistrationRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1RegistrationsPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1RegistrationsPost(firstRegistrationRequest, callback) {
      let postBody = firstRegistrationRequest;
      // verify the required parameter 'firstRegistrationRequest' is set
      if (firstRegistrationRequest === undefined || firstRegistrationRequest === null) {
        throw new Error("Missing the required parameter 'firstRegistrationRequest' when calling agentV1RegistrationsPost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/registrations', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1SalesNotesUsersGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1SalesNotesUsersGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AgentUserSalesNote>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 営業記録情報一覧取得
     * @param {module:api/PropallyAgentV1Api~agentV1SalesNotesUsersGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AgentUserSalesNote>}
     */
    agentV1SalesNotesUsersGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AgentUserSalesNote];
      return this.apiClient.callApi(
        '/agent/v1/sales_notes/users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1SalesNotesUsersUserIdPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1SalesNotesUsersUserIdPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentUserSalesNote} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 営業記録情報登録・更新
     * @param {Number} userId ユーザ ID
     * @param {module:model/AgentV1SalesNotesUsersUserIdPatchRequest} agentV1SalesNotesUsersUserIdPatchRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1SalesNotesUsersUserIdPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentUserSalesNote}
     */
    agentV1SalesNotesUsersUserIdPatch(userId, agentV1SalesNotesUsersUserIdPatchRequest, callback) {
      let postBody = agentV1SalesNotesUsersUserIdPatchRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1SalesNotesUsersUserIdPatch");
      }
      // verify the required parameter 'agentV1SalesNotesUsersUserIdPatchRequest' is set
      if (agentV1SalesNotesUsersUserIdPatchRequest === undefined || agentV1SalesNotesUsersUserIdPatchRequest === null) {
        throw new Error("Missing the required parameter 'agentV1SalesNotesUsersUserIdPatchRequest' when calling agentV1SalesNotesUsersUserIdPatch");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentUserSalesNote;
      return this.apiClient.callApi(
        '/agent/v1/sales_notes/users/{user_id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * すべてのユーザ一覧取得
     * @param {Object} opts Optional parameters
     * @param {Number} [page = 1)] 表示したいページ番号
     * @param {Number} [perPage = 30)] 1ページあたりの件数
     * @param {module:model/String} [sort = 'id_desc')] ソート順
     * @param {module:api/PropallyAgentV1Api~agentV1UsersGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedUsersResponse}
     */
    agentV1UsersGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'per_page': opts['perPage'],
        'sort': opts['sort']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = PaginatedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/users', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersSearchPost operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersSearchPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedUsersResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザ検索
     * @param {Object} opts Optional parameters
     * @param {module:model/UserSearchEnvelopeRequest} [userSearchEnvelopeRequest] 
     * @param {module:api/PropallyAgentV1Api~agentV1UsersSearchPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedUsersResponse}
     */
    agentV1UsersSearchPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['userSearchEnvelopeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = PaginatedUsersResponse;
      return this.apiClient.callApi(
        '/agent/v1/users/search', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdAssessmentProposalsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdAssessmentProposalsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AssessmentProposal>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 対象ユーザ査定提案済み一覧
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdAssessmentProposalsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AssessmentProposal>}
     */
    agentV1UsersUserIdAssessmentProposalsGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdAssessmentProposalsGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [AssessmentProposal];
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/assessment_proposals', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdFavoriteDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdFavoriteDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入りユーザ解除
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdFavoriteDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1UsersUserIdFavoriteDelete(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdFavoriteDelete");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/favorite', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdFavoritePatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdFavoritePatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * お気に入りユーザ登録
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdFavoritePatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1UsersUserIdFavoritePatch(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdFavoritePatch");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/favorite', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/User} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザ情報1件取得
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/User}
     */
    agentV1UsersUserIdGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = User;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdInvestmentProposalsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdInvestmentProposalsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InvestmentProposal>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 対象ユーザ投資提案済み一覧
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdInvestmentProposalsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InvestmentProposal>}
     */
    agentV1UsersUserIdInvestmentProposalsGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdInvestmentProposalsGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [InvestmentProposal];
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/investment_proposals', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdInvestmentStyleDiagnosisGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdInvestmentStyleDiagnosisGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvestmentStyleDiagnosisAgent} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 投資スタイル診断結果取得
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdInvestmentStyleDiagnosisGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvestmentStyleDiagnosisAgent}
     */
    agentV1UsersUserIdInvestmentStyleDiagnosisGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdInvestmentStyleDiagnosisGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = InvestmentStyleDiagnosisAgent;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/investment_style_diagnosis', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdMemoGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdMemoGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentUserMemo} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 対象エージェントのユーザメモ取得
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdMemoGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentUserMemo}
     */
    agentV1UsersUserIdMemoGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdMemoGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = AgentUserMemo;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/memo', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdMemoPatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdMemoPatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AgentUserMemo} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 対象エージェントのユーザメモ登録 or 更新
     * @param {Number} userId ユーザ ID
     * @param {Object} opts Optional parameters
     * @param {module:model/AgentUserMemo} [agentUserMemo] 
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdMemoPatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AgentUserMemo}
     */
    agentV1UsersUserIdMemoPatch(userId, opts, callback) {
      opts = opts || {};
      let postBody = opts['agentUserMemo'];
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdMemoPatch");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = AgentUserMemo;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/memo', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdPropertiesGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdPropertiesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Property>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザの物件一覧取得
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdPropertiesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/Property>}
     */
    agentV1UsersUserIdPropertiesGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdPropertiesGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Property];
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/properties', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdProposalMatchingsGet operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdProposalMatchingsGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ProposalMatching>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * 対象ユーザマッチ済み一覧
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdProposalMatchingsGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ProposalMatching>}
     */
    agentV1UsersUserIdProposalMatchingsGet(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdProposalMatchingsGet");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [ProposalMatching];
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/proposal_matchings', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdScoreDelete operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdScoreDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザスコア削除
     * @param {Number} userId ユーザ ID
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdScoreDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1UsersUserIdScoreDelete(userId, callback) {
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdScoreDelete");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/score', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the agentV1UsersUserIdScorePatch operation.
     * @callback module:api/PropallyAgentV1Api~agentV1UsersUserIdScorePatchCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseMessage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * ユーザスコア登録
     * @param {Number} userId ユーザ ID
     * @param {module:model/ScoreRequest} scoreRequest 
     * @param {module:api/PropallyAgentV1Api~agentV1UsersUserIdScorePatchCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseMessage}
     */
    agentV1UsersUserIdScorePatch(userId, scoreRequest, callback) {
      let postBody = scoreRequest;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling agentV1UsersUserIdScorePatch");
      }
      // verify the required parameter 'scoreRequest' is set
      if (scoreRequest === undefined || scoreRequest === null) {
        throw new Error("Missing the required parameter 'scoreRequest' when calling agentV1UsersUserIdScorePatch");
      }

      let pathParams = {
        'user_id': userId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseMessage;
      return this.apiClient.callApi(
        '/agent/v1/users/{user_id}/score', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
